import React from 'react';

import { ReactComponent as LogoLight } from '../assets/logo_light.svg';
import { routeIds } from '../i18n/routes';
import { useI18n } from '../i18n/I18nContext';

function TabAnchor({ href, content }) {
  return (
    <li><a className="text-white text-base transition duration-300 hover:opacity-50" href={href}>{content}</a></li>
  );
}

function SocialLink({ href, icon }) {
  return (
    <li><a className="text-accent text-4xl transition duration-300 hover:opacity-50" href={href} target="_blank">{icon}</a></li>
  );
}

function Footer({route}) {
  const { pathFor, t } = useI18n();

  return (
    <div className="relative bg-primary-100 w-full px-10">
      <div className="relative max-w-[1200px] mx-auto relative z-20">
        <div className="flex w-full py-[3.125rem]">
          <div className="flex flex-col w-1/2 pr-4">
            <a className="w-full max-w-[261px] transition duration-300 hover:opacity-50" href={pathFor(routeIds.home)}><LogoLight className="w-full h-auto text-white" /></a>
            <div className="text-white text-xs pt-[1.625rem]">{t("footer.baseline")}</div>
          </div>
          <div className="flex w-1/2">
            <ul className="flex flex-col space-y-3">
              <TabAnchor href={pathFor(routeIds.expertise)} content={t("navigation.expertise")} />
              <TabAnchor href={pathFor(routeIds.projects)} content={t("navigation.projects")} />
              <TabAnchor href={pathFor(routeIds.team)} content={t("navigation.team")} />
              <TabAnchor href={pathFor(routeIds.contact)} content={t("navigation.contact")} />
            </ul>
            <ul className="flex flex-col space-y-3 sm:flex-row sm:space-x-9 sm:space-y-0 ml-auto">
              <SocialLink href="https://www.linkedin.com/company/cdo-apps" icon={<i class="fa-brands fa-linkedin"></i>} />
              <SocialLink href="https://facebook.com/61558388555678" icon={<i class="fa-brands fa-facebook"></i>} />
              <SocialLink href="https://www.instagram.com/pockethamstermania_game" icon={<i class="fa-brands fa-square-instagram"></i>} />
            </ul>
          </div>
        </div>
        <div className="w-full bg-primary-300 h-[1px]"></div>
        <div className="w-full text-white text-base text-center py-[3.125rem]"><a className="transition duration-300 hover:opacity-50" href={pathFor(routeIds.legalNotice)}>{t("footer.legalNotice")}</a> - {t("footer.rights")} © CDO Apps {new Date().getFullYear()}</div>
      </div>
    </div>
  );
}

export default Footer;
